import React from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { setSingleDayLabelAction } from '../../../../redux/slices/analyses';
import { SvgIcon } from '../../../Icon';
import KubitTooltip from '../../../KubitTooltip';
import { theme } from '../../../../styles/theme';

const Container = styled.div`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  position: relative;
  padding: 16px 24px 0px 0;
  border: 1px solid ${theme.colors.border};
`;

const Wrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  background-color: ${theme.colors.border};
  color: ${theme.colors.secondary600};
  &:hover {
    cursor: pointer;
    color: ${theme.colors.mainBlue};
  }
`;

interface IProps {
  analysisId: string;
  children: React.ReactNode;
  /** case we need to ignore: histogram with all time, there is nothing to expand */
  ignoreCloseButton: boolean;
}

export default ({ analysisId, children, ignoreCloseButton }: IProps) => {
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(setSingleDayLabelAction({ analysisId, singleDayLabel: '' }));
  };

  // ignore the close button for histogram
  if (ignoreCloseButton) {
    return <>{children}</>;
  }

  return (
    <Container>
      <KubitTooltip content="Close" placement="bottom" noOpenDelay={true}>
        <Wrapper onClick={handleClick}>
          <SvgIcon
            name="icon-x"
            width={10}
            height={10}
            customFill="currentColor"
          />
        </Wrapper>
      </KubitTooltip>
      {children}
    </Container>
  );
};
